import { fr_agents } from '../heineken_template/_fr/fr_agents';
import { TemplateProps } from '../heineken_template/_private/TemplateProps';
import { boleStock_init } from './_private/boleStock_init';
const templateProps = new TemplateProps();
if (fr_agents.is['bole@web_stock'])
    boleStock_init.indexPage(templateProps);
export default templateProps.NextPage;
